import BottomNavigation from '@src/main/ui/components/layout/common/Navbar/NavbarMobile/BottomNavigation/BottomNavigation';

import { type FC } from 'react';

const NavbarMobile: FC = () => (
  <>
    <BottomNavigation />
  </>
);

export default NavbarMobile;
